// extracted by mini-css-extract-plugin
module.exports = {"statsBanner":"StatsBanner_statsBanner__2ii2t","statsBannerItem":"StatsBanner_statsBannerItem__3r-Og"};